// Room inspiration is separate from native finish/variant previews.
document.querySelectorAll('[data-product-gallery]').forEach(gallery => {
  const controls = gallery.querySelector('[data-lifestyle-controls]');
  const nativeImages = gallery.querySelector('[data-native-product-images]');
  const room = gallery.querySelector('[data-lifestyle-product-room]');
  if (!controls || !nativeImages || !room) return;
  controls.hidden = false;
  function showRoom(inRoom) {
    nativeImages.hidden = inRoom;
    room.hidden = !inRoom;
    controls.querySelectorAll('[data-lifestyle-view]').forEach(button => button.setAttribute('aria-pressed', String((button.dataset.lifestyleView === 'room') === inRoom)));
    if (inRoom) {
      const image = room.querySelector('img');
      if (image && !image.getAttribute('src')) {
        image.sizes = image.dataset.roomSizes;
        image.srcset = image.dataset.roomSrcset;
        image.src = image.dataset.roomSrc;
      }
    } else { window.dispatchEvent(new Event('resize')); }
  }
  controls.addEventListener('click', event => {
    const button = event.target.closest('[data-lifestyle-view]');
    if (button) showRoom(button.dataset.lifestyleView === 'room');
  });
  document.querySelector('.product-form')?.addEventListener('change', () => showRoom(false));
});
